// extracted by mini-css-extract-plugin
export default {"PlainFeature":"wg_a bht_b"};